var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkcircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -70.4590 92.5300 70.4590",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2402 4.15039C68.0176 4.15039 85.6934-13.4766 85.6934-35.2539C85.6934-57.0312 68.0176-74.6582 46.2402-74.6582C24.5117-74.6582 6.83594-57.0312 6.83594-35.2539C6.83594-13.4766 24.5117 4.15039 46.2402 4.15039ZM46.2402-3.27148C28.5645-3.27148 14.3066-17.5781 14.3066-35.2539C14.3066-52.9297 28.5645-67.2363 46.2402-67.2363C63.916-67.2363 78.2227-52.9297 78.2227-35.2539C78.2227-17.5781 63.916-3.27148 46.2402-3.27148Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.041-17.0898C43.457-17.0898 44.6777-17.7734 45.5566-19.1406L62.3535-45.7031C62.8906-46.582 63.4277-47.5586 63.4277-48.5352C63.4277-50.4883 61.7188-51.709 59.8633-51.709C58.7402-51.709 57.666-51.0742 56.8359-49.7559L41.8457-25.4395L35.1074-34.5215C34.0332-35.9375 33.0566-36.2793 31.8848-36.2793C29.9805-36.2793 28.5156-34.7656 28.5156-32.8125C28.5156-31.8848 28.9062-30.957 29.4922-30.127L38.2812-19.1406C39.4043-17.6758 40.5762-17.0898 42.041-17.0898Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkcircle);
export default __webpack_public_path__ + "static/media/checkmark.circle.17cd6a0b652869f48ad971abdf56ae61.svg";
export { ForwardRef as ReactComponent };